angular.module('invoice')
    .controller('InvoiceShowController', function ($scope, $rootScope, $uibModalInstance, data, Invoice, InvoiceService, InvoiceConst, Principal) {
        this.InvoiceService = InvoiceService
        this.Principal = Principal

        this.$onInit = () => {
            Invoice.get({id: data.id}).$promise.then(item => {
                this.item = item
                Invoice.touches({id: this.item.id}).$promise.then(items => this.touches = items)
            })
            this.canReadInvoiceBgt = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_BGT_READ', 'ROLE_INVOICE_DOCUMENTS_BGT_WRITE_WITH_READ_ACCESS', 'ROLE_ADMIN'])
            this.canReadSubcontractorStatements = Principal.hasAnyAuthority([
                'ROLE_INVOICE_DOCUMENTS_SUBCONTRACTOR_STATEMENTS_READ',
                'ROLE_INVOICE_DOCUMENTS_SUBCONTRACTOR_STATEMENTS_WRITE_WITH_READ_ACCESS',
                'ROLE_ADMIN'
            ])
            this.canResetKsefXmlExport = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_EXPORT'])
            this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD'])
        }
        this.resetKsefXmlExport = () => {
            if (!this.item || !this.item.id) {
                return
            }
            return InvoiceService.resetKsefXmlExport([this.item.id])
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.canCancel = () => true
        $scope.$on(InvoiceConst.eventUpdate, () => {
            $rootScope.$broadcast('document.comments.reload', this.item.id)
            this.$onInit()
        })
        $scope.$on("file.saved", () => this.$onInit())
    })
